import { DEFAULT_IMAGE_QUALITY } from '@const/index';
import getPublicEnv from '@utils/getPublicEnv';

const getImageQuality = (): number =>
  Number(process.env.IMAGE_QUALITY) || Number(getPublicEnv('NEXT_PUBLIC_IMAGE_QUALITY')) || DEFAULT_IMAGE_QUALITY;

export default getImageQuality;
